<template>
    <el-select
    v-model="model"
    :multiple="multiple"
    filterable
    remote
    reserve-keyword
    placeholder="请输入关键词以搜索单位"
    :remote-method="remoteMethod"
    :loading="loadingController"
    :disabled="disabled"
    @change="changeHandler"
    class="select-dw"
    >
        <el-option
            v-for="item in options"
            :key="item[props.value]"
            :label="item[props.label]"
            :value="item[props.value]"
            style="min-width: 415px; "
        >
        </el-option>
    </el-select>
</template>

<script>
import MODEL from '@/mixins/model'
import TWO_WAY from '@/mixins/2way'

export default {
	props: {
		placeholder: {
			type: String,
			default: ''
		},
		procode: {
			type: String,
			default: ''
		},
        value: {
            type: [Array, String],
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        modelStr: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        strSpliter: {
            type: String,
			default: ','
        },
        zgys: {
            type: Boolean,
			default: false
        },
        isXt: {
            type: String,
			default: ''
        },
        bdcodes: {
            type: String,
			default: ','
        },
        yqdwcode: {
            type: String,
			default: ','
        }
	},
	mixins: [MODEL, TWO_WAY],
	data() {
		return {
			options: [],
            optionsMap: {},

			props: {
				value: 'dwcode',
				label: 'dwcnname'
			},

            loadingController: false
		};
	},
    computed: {
        model: {
            get() {
                if(this.multiple && this.modelStr) {
                    var value = this.value || '';

                    var valueArr = value.split(this.strSpliter);
                    if(valueArr[0] === '') {
                        return valueArr.slice(1);
                    } else {
                        return valueArr;
                    };
                } else {
                    return this.value;
                };
            },
            set(val) {
                this.twoWayHandler(val);
                if(this.multiple && this.modelStr) {
                    this.$emit('input', val.join(this.strSpliter));
                } else {
                    this.$emit('input', val);
                };
            }
        }
    },
    watch: {
        value: {
            handler(n, o) {
                this.setSeledOptions();
            }, deep: true
        }
    },
	methods: {
		changeHandler(val) {
            this.$emit('change', val);
		},
        remoteMethod(query) {
            if(!query) return;
            this.loadingController = true;
            if(!this.zgys&&(this.isXt==0||this.isXt==undefined)) {
                this.$ajax({
                                url: `${this.getGetters('bidUrl')}/revision/tree/getdw.json`,
                                data: {
                                    txtkey: query,
                                    zbprocode: this.procode
                                },
                                callback: data => {
                                    var arr;
                                    try{
                                        arr = JSON.parse(data);
                                    } catch(e) {
                                        arr = data;
                                    };

                                    this.options = this.margeArr(arr, this.options);
                                },
                                complete: () => {
                                    this.loadingController = false;
                                }
                            })
            }
            if(this.isXt==1) {
                this.$ajax({
                                url: `${this.getGetters('bidUrl')}/revision/tree/getdw.json`,
                                data: {
                                    txtkey: query,
                                    zbprocode: this.procode
                                },
                                callback: data => {
                                    var arr;
                                    try{
                                        arr = JSON.parse(data);
                                    } catch(e) {
                                        arr = data;
                                    };

                                    this.options = this.margeArr(arr, this.options);
                                },
                                complete: () => {
                                    this.loadingController = false;
                                }
                            })
            }
          
        },
        twoWayHandler(value) {
            if(this['2way']) {
               var modelArr = this['2way'].split(',');
               var updateItem = this.fetchItemInMap(value)
               modelArr.forEach(key => {
                   var toUpdate = updateItem.map(item => {
                       return item[key]
                   });

                   if((this.multiple && this.modelStr) || !this.multiple) {
                       toUpdate = toUpdate.join(this.strSpliter);
                   };
                   this.$emit('update:' + key, toUpdate);
               });
           };
        },
        fetchItemInMap(value) {
            var mapedArr = [];
            if(getType(value) === 'array') {
                value.forEach(item => {
                    mapedArr.push(this.optionsMap[item])
                });
            } else if(getType(value) === 'string') {
                if(this.multiple && this.modelStr) {
                    var valueArr = value.split(this.strSpliter);
                    valueArr.forEach(item => {
                        mapedArr.push(this.optionsMap[item])
                    });
                } else {
                    mapedArr.push(this.optionsMap[value])
                };
            };

            return mapedArr;
        },
        margeArr(from, to) {
            var cloneTo = clone(to);

            from.forEach(item => {
                if(cloneTo.every(toItem => {
                    return (JSON.stringify(toItem) !== JSON.stringify(item))
                })) {
                    this.setMap(item);
                    // cloneTo.push(item);
                };
            });

            // return cloneTo;
            return from;
        },
        setMap(item) {
            this.optionsMap[item[this.props['value']]] = item;
        },
        setSeledOptions() {
            if(this.value && !this.options.length) {
                var arr = [];
                if(this['2way']) {
                   var modelArr = this['2way'].split(',');
                   modelArr.forEach((key, index) => {
                       var bindValue = this.valueBreaker(key);

                       arr.push({
                           key,
                           value: bindValue
                       });
                   });
               };

               var modelValue = this.valueBreaker('value');
               arr.push({
                   key: this.props.value,
                   value: modelValue
               });

               var seledArr = [];
               arr[0].value.forEach((item, index) => {
                   var obj = {};
                   arr.forEach((valueItem, valueIndex) => {
                       obj[valueItem.key] = valueItem.value[index]
                   });
                   seledArr.push(obj);
               });

                this.options = this.margeArr(seledArr, this.options);
            };
        },
        valueBreaker(key) {
            var bindValue = this[key] || this.$attrs[key];

            if((this.multiple && this.modelStr) || !this.multiple) {
                bindValue = bindValue.split(this.strSpliter);
            };

            if(getType(bindValue) === 'string') {
                return [bindValue];
            };

            return bindValue;
        }
	},
	created() {
        this.setSeledOptions();  
	}
}
</script>

<style >
.select-dw{width:100%;}
/deep/ .el-select-dropdown{
max-height: 274px;
min-width: 415px!important;
}
/deep/ .el-scrollbar {
    overflow: hidden;
    width: 415px;
}
/deep/ .el-select-dropdown__list {
    width:415px
}
/deep/ .el-select-dropdown__item {
    width:415px!important
}
</style>
